export const formatWithThousandSeparators = (
  value: string | number | null | undefined
): string => {
  if (value === null || value === undefined) return '0';

  const str = value.toString();

  const match = str.match(/^([£$€]?)(-?\d+\.?\d*)(.*)$/);
  if (match) {
    const [, prefix, numStr, suffix] = match;
    const num = parseFloat(numStr);
    if (!isNaN(num)) {
      const formatted = num.toLocaleString('en-GB', {
        minimumFractionDigits: numStr.includes('.') ? 2 : 0,
        maximumFractionDigits: 2,
      });
      return `${prefix}${formatted}${suffix}`;
    }
  }

  return str;
};
